import {
  collection, addDoc, query, where, orderBy,
  getDocs, deleteDoc, doc, Timestamp, limit,
} from 'firebase/firestore';
import { db } from '../firebaseConfig';
import { QuoteState, SavedQuote } from '../types';

export const saveQuote = async (userId: string, quote: QuoteState): Promise<string> => {
  const totalMrc = quote.items.reduce((sum, item) => sum + item.mrc * item.lines, 0);
  const ref = await addDoc(collection(db, 'quotes'), {
    userId,
    apiContent:   quote,
    createdAt:    Timestamp.now(),
    customerName: quote.customerName || 'Untitled Quote',
    companyName:  quote.companyName  || '',
    mrc:          totalMrc,
    term:         quote.term,
  });
  return ref.id;
};

export const getQuotes = async (userId: string): Promise<SavedQuote[]> => {
  const q = query(
    collection(db, 'quotes'),
    where('userId', '==', userId),
    orderBy('createdAt', 'desc'),
    limit(50)
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({
    id:           d.id,
    userId:       d.data().userId,
    customerName: d.data().customerName,
    companyName:  d.data().companyName,
    createdAt:    (d.data().createdAt as Timestamp).toDate(),
    mrc:          d.data().mrc,
    term:         d.data().term,
    apiContent:   d.data().apiContent as QuoteState,
  }));
};

export const deleteQuote = async (quoteId: string): Promise<void> => {
  await deleteDoc(doc(db, 'quotes', quoteId));
};
